import Vue from 'vue'                                   // Vue.js
import Vuex from 'vuex';                                // State management
const stringify = require('json-stringify-safe')


//------------------------------------ VARS --------------------------------//
Vue.use(Vuex)

//==========================================================================//
//                                                                          //
//                               STATE MANAGEMENT                           //
//                                                                          //
//==========================================================================//

const loadState = (bID) => {
	try {
		const serializedState = window.localStorage.getItem('MerchantBanners' + bID);
		var output = JSON.parse(serializedState || "");
		if (output.constructor === {}.constructor){
			return output;			
		}
		return undefined;
	} catch (err) {
		return undefined;
	}
};

const saveState = (state, bID) => {
	try {
		const serializedState = stringify(state);
		window.localStorage.setItem('MerchantBanners' + bID, serializedState);
	} catch (err) {
		console.error(`Something went wrong: ${err}`);
	}
}


//==========================================================================//
//                                                                          //
//                                  STORE                                   //
//                                                                          //
//==========================================================================//

const store = new Vuex.Store({
    //------------------------------- STATE --------------------------------//
    state:{
        // User
        adTime: 0,
        orders: [],
        language: "en-uk"
    },
    getters: {
    	getAdTime: (state) =>() =>{
    		return state.adTime || 0;
    	},
    	getOrders: (state) =>() =>{
    		return state.orders || [];
    	},
    	getLanguage: (state) =>() =>{
    		return state.language || "en-uk";
    	},
    },


    //----------------------------- MUTATIONS ------------------------------//
    mutations: {
        // SAVE LOAD
        loadState(state, bID){
        	this.replaceState(loadState(bID) || {
        		adTime: 0,
        		orders: [],
        		language: "en-uk"
        	});
        },
        clearCache(state){
        	window.localStorage.removeItem('MerchantBanners');
        },


        // UPDATING
        updateAdTime(state, input){
        	state.adTime = input.time;
        	saveState(state, input.bID);
        },
        updateOrders(state, input){
        	if (state.orders === [].constructor){

        	}
        	state.orders = input.orders;
        	saveState(state, input.bID);
        },
        updateLanguage(state, input){
        	state.language = input.language;
        	saveState(state, input.bID);
        },

    },
});

//---------------------------------- EXPORT --------------------------------//
export {
	store,
}


// WEBPACK FOOTER //
// ./src/store.js